var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.269 1c1.052 0 1.914.873 1.93 1.948l.001.033v12.038c0 1.08-.85 1.963-1.9 1.98l-.03.001h-4.404a.47.47 0 0 1-.465-.477c0-.26.201-.47.452-.477h4.417c.543 0 .99-.454 1-1.009V2.981c0-.557-.441-1.016-.982-1.026h-4.422a.47.47 0 0 1-.465-.478c0-.259.201-.47.452-.477h4.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.884 13.42.87 9.31a.4.4 0 0 1-.097-.152.5.5 0 0 1 0-.35.4.4 0 0 1 .097-.153l4.014-4.141a.485.485 0 0 1 .687-.008.49.49 0 0 1 .008.69L2.368 8.48h12.288a.486.486 0 0 1 0 .974H2.368l3.21 3.284a.49.49 0 0 1-.007.69.485.485 0 0 1-.687-.008"
  }))));
};
export default SvgLogout;